import { render } from "./InterfaceTabHeader.vue?vue&type=template&id=08a5d978&scoped=true"
import script from "./InterfaceTabHeader.vue?vue&type=script&lang=js"
export * from "./InterfaceTabHeader.vue?vue&type=script&lang=js"

import "./InterfaceTabHeader.vue?vue&type=style&index=0&id=08a5d978&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a5d978"]])

export default __exports__